import { httpMethod, useApi } from './useApi';
export const useCreateInvoice = () => {
    const { call, data, error, ...rest } = useApi({
        authenticated: true,
        path: 'invoices',
        httpMethod: httpMethod.POST,
        body: {},
    });
    const callFunction = (body) => {
        call(body);
    };
    const responseData = data;
    return { call: callFunction, data: responseData, error, ...rest };
};
export const useGetInvoices = () => {
    const { call, data, error, ...rest } = useApi({
        authenticated: true,
        path: 'invoices',
        httpMethod: httpMethod.GET,
        body: {},
        queryParams: {},
    });
    const responseData = data;
    return { call, data: responseData, error, ...rest };
};
export const useUpdateInvoice = () => {
    const { call, data, error, ...rest } = useApi({
        authenticated: true,
        path: 'invoices',
        httpMethod: httpMethod.PUT,
        body: {},
    });
    const callFunction = (body) => {
        call(body);
    };
    const responseData = data;
    return { call: callFunction, data: responseData, error, ...rest };
};
export const useDeleteInvoice = () => {
    const { call, data, error, ...rest } = useApi({
        authenticated: true,
        path: 'invoices',
        httpMethod: httpMethod.DELETE,
        body: {},
    });
    const callFunction = (body) => {
        call(body);
    };
    const responseData = data;
    return { call: callFunction, data: responseData, error, ...rest };
};
